// extracted by mini-css-extract-plugin
export default {"title":"certificationScope_title__EKvFO","bigFontTable":"certificationScope_bigFontTable__ijezV"};